module.exports = __webpack_public_path__ + "media/images/icon-plus-big-ac19c0142fe76d3cf24215e99c0dd392.svg";